import handleFetch from '../utils/handleFetch';
import { getUrlWithAccessCode } from '../stores/referrer';

/**
 * fetch card data from SAAS endpoint
 * @see {@link https://docs.insiderx.com/membership_card/json/}
 *
 * @returns {Promise<object>}
 */
const fetchCard = () => {
  const headers = {
    'x-api-key': `${process.env.SAAS_API_KEY}`,
  };
  return handleFetch(getUrlWithAccessCode(`${process.env.SAAS_CARD_JSON_ENDPOINT}`), {
    headers,
    errorKey: 'Error fetching card from SAAS endpoint.',
  });
};

export default fetchCard;
